import Stack from "react-bootstrap/Stack";
import { useState } from "react";
import ResultBodyNav from "./ResultBodyNav";
import Endpoints from "./Endpoints";
import ExperimentalDesign from "./ExperimentalDesign";
import SmilesRenderer from "./SmilesRenderer";
import PODs from "./PODs";
import { observer } from "mobx-react-lite";

function ResultBody({ store, ref, isPrinting }) {
  const [tab, setTab] = useState("endpoint");
  let endpointComponent = (
    <Endpoints store={store} isPrinting={isPrinting} />
  );
  let bmdComponent = <PODs store={store} isPrinting={isPrinting} />;
  let expComponent = (
    <ExperimentalDesign
      store={store}
      isPrinting={isPrinting}
    />
  );
  if (isPrinting) {
    return (
      <div className="result-body" ref={ref}>
        <div className="title-page-container">
            <img src={`${process.env.PUBLIC_URL}/Logo.png`} className="report-title-logo" alt="Title Image"></img>
            <SmilesRenderer smiles={store.runObject.smiles} height="600" width="600" />
            <div className="report-smiles">{store.runObject.smiles}</div>
            <div className="print-page-break" />
        </div>
        <h2>Endpoint Sensitivity</h2>
        {endpointComponent}
        <div className="print-page-break" />
        <h2>Toxicity Values</h2>
        {bmdComponent}
        <div className="print-page-break" />
        <h2>Experimental Design</h2>
        {expComponent}
      </div>
    );
  }
  let component;
  if (tab === "endpoint") {
    component = endpointComponent;
  } else if (tab === "experiment") {
    component = expComponent;
  } else {
    component = bmdComponent;
  }
  return (
    <Stack className="result-body" ref={ref}>
      <ResultBodyNav tab={tab} setTab={setTab} />
      {component}
    </Stack>
  );
}

export default observer(ResultBody);
